module.exports = __webpack_public_path__ + "static/media/arrow-back.aa70d789.svg";